var render = function render(){var _vm=this,_c=_vm._self._c;return _c('overlay',{attrs:{"show":_vm.show,"z-index":"9999"}},[_c('div',{staticClass:"overlayMain"},[_vm._v(" 请点击右下方使用完整服务 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }